import { InputProps } from '@chakra-ui/react';
import React from 'react';

import {
  CmInput,
  CmInputGroup,
  CmInputLeftElement,
} from '@/components/uiParts';
import { SearchIcon } from '@/components/uiParts';

type Props = {
  icon: 'search';
} & InputProps;

export const CmLeftIconAndInput: React.FC<Props> = ({ icon, ...rest }) => {
  const iconProps = {
    search: <SearchIcon color="gray.300" />,
  };
  return (
    <CmInputGroup>
      <CmInputLeftElement pointerEvents="none">
        {iconProps[icon]}
      </CmInputLeftElement>
      <CmInput pl="2.5rem" {...rest} />
    </CmInputGroup>
  );
};
